export function isVerticalEllipsisActive(e: HTMLElement): boolean {
  return e.scrollHeight > e.offsetHeight;
}

export function isHorizontalEllipsisActive(e: HTMLElement): boolean {
  return e.scrollWidth > e.offsetWidth;
}
